import React from "react";
import Navbar from "../components/Navbar";
import SearchMain from "../components/Search/SearchMain";

const Search = () => {
  return (
    <div>
      <Navbar />
      <div className="background">
        <SearchMain />
      </div>
    </div>
  );
};

export default Search;
